/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DismissQuoteDTO,
  ErrorResponse,
  QuoteDTO,
  QuoteValidationParamsDTO,
  RequestDTO,
  RequestDisplayDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class QuoteApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags quote-api
   * @name ConfirmQuote
   * @summary Confirm a quote
   * @request POST:/api/quotes/{id}/confirm
   * @secure
   */
  confirmQuote = (
    id: number,
    query: {
      /** @format int32 */
      quantityOptionUsed: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/quotes/${id}/confirm`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags quote-api
   * @name DismissQuote
   * @summary Dismiss a quote
   * @request POST:/api/quotes/{id}/dismiss
   * @secure
   */
  dismissQuote = (
    id: number,
    data: DismissQuoteDTO,
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/quotes/${id}/dismiss`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags quote-api
   * @name GetOrCreateQuote
   * @summary Get or create a quote filled with the request data
   * @request GET:/api/quotes/get-or-create
   * @secure
   */
  getOrCreateQuote = (
    query: {
      /** @format int64 */
      requestId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<QuoteDTO, ErrorResponse | QuoteDTO>({
      path: `/api/quotes/get-or-create`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags quote-api
   * @name GetQuoteVersions
   * @summary Get all quote versions for the current company on a request
   * @request GET:/api/quotes/versions
   * @secure
   */
  getQuoteVersions = (
    query: {
      /**
       * The ID of the request
       * @format int64
       */
      requestId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<QuoteDTO[], ErrorResponse | QuoteDTO[]>({
      path: `/api/quotes/versions`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags quote-api
   * @name GiveFeedback
   * @summary Give feedback on a submitted quote
   * @request POST:/api/quotes/{id}/feedback
   * @secure
   */
  giveFeedback = (
    id: number,
    query: {
      /**
       * @minLength 1
       * @maxLength 1000
       */
      feedback: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/quotes/${id}/feedback`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags quote-api
   * @name RejectRequest
   * @summary Reject a request
   * @request POST:/api/quotes/reject-request
   * @secure
   */
  rejectRequest = (
    query: {
      /**
       * The ID of the request to be rejected
       * @format int64
       */
      requestId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestDisplayDTO, ErrorResponse | RequestDisplayDTO>({
      path: `/api/quotes/reject-request`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags quote-api
   * @name RevokeRejectedRequestAsOfferor
   * @summary Revoke the rejection of a request as an offerer
   * @request POST:/api/quotes/revoke-rejected-request/{requestId}
   * @secure
   */
  revokeRejectedRequestAsOfferor = (
    requestId: number,
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/quotes/revoke-rejected-request/${requestId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags quote-api
   * @name SubmitQuote
   * @summary Submit quote
   * @request POST:/api/quotes/submit
   * @secure
   */
  submitQuote = (data: QuoteDTO, params: RequestParams = {}) =>
    this.request<QuoteDTO, ErrorResponse | QuoteDTO>({
      path: `/api/quotes/submit`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags quote-api
   * @name SubmitRevisedQuote
   * @summary Submit a revised quote based on a previously IN_NEGOTIATION quote
   * @request POST:/api/quotes/{id}/submit-revised
   * @secure
   */
  submitRevisedQuote = (
    id: number,
    data: QuoteDTO,
    params: RequestParams = {},
  ) =>
    this.request<QuoteDTO, ErrorResponse | QuoteDTO>({
      path: `/api/quotes/${id}/submit-revised`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Validates that the provided quote and request date parameters are mutually consistent. Returns a list of validation errors, or an empty result if all dates are valid.
   *
   * @tags quote-api
   * @name ValidateQuoteDates
   * @summary Validate quote and request date constraints
   * @request POST:/api/quotes/validate-dates
   * @secure
   */
  validateQuoteDates = (
    data: QuoteValidationParamsDTO,
    params: RequestParams = {},
  ) =>
    this.request<ErrorResponse, ErrorResponse>({
      path: `/api/quotes/validate-dates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags quote-api
   * @name WithdrawQuote
   * @summary Withdraw a quote
   * @request POST:/api/quotes/{id}/withdraw
   * @secure
   */
  withdrawQuote = (id: number, params: RequestParams = {}) =>
    this.request<QuoteDTO, ErrorResponse | QuoteDTO>({
      path: `/api/quotes/${id}/withdraw`,
      method: "POST",
      secure: true,
      ...params,
    });
}
